<template>
    <page>
        <module>
            <module-tab title="网站配置" >
                <c-form ref="form1">
                        <c-form-item type="input" label="平台名称【中文】" name="PLATFORM_NAME_ZH"></c-form-item>
                        <c-form-item type="input" label="平台名称【英文】" name="PLATFORM_NAME_EN"></c-form-item>
                        <c-form-item type="textarea" label="网站描述【中文】" name="PC_DESCRIPTION_ZH"></c-form-item>
                        <c-form-item type="textarea" label="网站描述【英文】" name="PC_DESCRIPTION_EN"></c-form-item>
                        <c-form-item type="textarea" label="网站关键词【中文】" name="PC_KEYWORDS_ZH"></c-form-item>
                        <c-form-item type="textarea" label="网站关键词【英文】" name="PC_KEYWORDS_EN"></c-form-item>
                        <c-form-item type="input" label="ICP备案信息" name="ICP"></c-form-item>
                        <c-form-item type="input" label="公安备案信息" name="BEIAN"></c-form-item>
                        <c-form-item type="input" label="公安备案链接" name="BEIAN_LINK"></c-form-item>
                        <!-- <c-form-item type="input" label="电信许可证号" name="TELE_LICENCE_NUMBER"></c-form-item>
                        <c-form-item type="image" label="电信许可证图片" name="TELE_LICENCE_IMG" file-word="请上传电信许可证图片信息,【支持jpg、jpeg、png】"></c-form-item> -->
                        <c-form-item type="input" label="版权信息【中文】" name="COPYRIGHT_ZH"   ></c-form-item>
						<c-form-item type="input" label="版权信息【英文】" name="COPYRIGHT_EN"   ></c-form-item>
                </c-form>
            </module-tab>
            <module-tab title="邮箱配置" >
                <c-form ref="form3">
                    <c-form title="邮箱服务器">
                        <c-form-item type="select" label="邮箱类型" name="EMAIL_TRANSPORT_PROTOCOL" :options="protocolOptions" disabled></c-form-item>
                        <c-form-item type="input" label="服务地址" name="EMAIL_HOST" word="请填写发件邮箱服务地址，例如：smtp.qiye.aliyun.com"></c-form-item>
                        <c-form-item type="number" label="服务器端口" name="EMAIL_PORT"></c-form-item>
                        <c-form-item type="radio" label="是否开启SSL" :options="switchOptions" name="EMAIL_SSL" word="如果设置为“开启”，则默认情况下使用SSL连接并使用SSL端口。对于“smtp”协议，默认为false；对于“smtps”协议，默认为true。"></c-form-item>
                        <c-form-item type="radio" label="AUTH命令验证身份" :options="switchOptions" name="EMAIL_SMTP_AUTH"  word="开启则使用AUTH命令对用户进行身份验证"></c-form-item>
                    </c-form>
                    <c-form title="邮箱信息">
                        <c-form-item type="input" label="邮箱账号" name="EMAIL_SERVICE_USER" word="发送验证码等信息的邮箱地址，例如：test@163.com"></c-form-item>
                        <c-form-item type="input" label="邮箱密码" name="EMAIL_SERVICE_PASSWORD" word="请填写发件邮箱的密码信息"></c-form-item>
                        <c-form-item type="input" label="邮箱名称" name="EMAIL_SERVICE_USER_NAME" word="该名称将作为发件人展示"></c-form-item>
                    </c-form>
                    <c-form title="接收通知邮箱">
                        <c-form-item type="input" label="定制需求通知邮箱" name="FEEDBACK_NOTICE_EMAIL" word="客户提交定制需求后，将会给该邮箱发送通知邮件"></c-form-item>
                    </c-form>
                </c-form>
            </module-tab>
            <module-tab title="运营后台配置" >
                <c-form ref="form2">
                        <c-form-item type="input" label="系统名称" name="OMS_SYSTEM_NAME"></c-form-item>
                        <c-form-item type="image" label="登录页Logo" name="OMS_LOGIN_LOGO" file-word="【建议尺寸：140X140px,支持jpg、png，图片大小1M以内】"></c-form-item>
                        <c-form-item type="image" label="内页Logo" name="OMS_LOGO" file-word="【建议尺寸：200X150px,支持jpg、png，图片大小1M以内，最好是透明图】"></c-form-item>
                        <c-form-item type="image" label="ICON图标" name="OMS_FAVICON" file-word="【建议尺寸：32X32px,支持jpg、png，图片大小1M以内】"></c-form-item>
                        <c-form-item type="input" label="版权信息" name="OMS_COPYRIGHT" ></c-form-item>
                        <c-form-item type="input" label="后台访问地址" name="OMS_URL" ></c-form-item>
                </c-form>
            </module-tab>

            <template slot="button">
                <c-button size="m" power="m_mall_config" @click="save()">保存</c-button>
            </template>
        </module>
    </page>
</template>

<script>
	import {mapState} from 'vuex'
	
    export default {
        name: 'm_mall_config',

        components: {
        },

        props: {
            id: String
        },

        data() {
            return {
                fromData:{
                },
                protocolOptions: [
                    {name: 'SMTP',value: 'smtp'},
                    {name: 'IMAP',value: 'imap'},
                    {name: 'POP3',value: 'pop3'}
                ],
                switchOptions: [{
                    name: '开启',
                    value: 'ON'
                }, {
                    name: '关闭',
                    value: 'OFF'
                }],
	            outstockOptions: [{
		            name: '不支持',
		            value: '0'
	            }, {
		            name: '支持',
		            value: '1'
	            }],
            }
        },
        computed: {
          ...mapState(['systemConfig'])
        },

        watch: {

        },

        mounted() {
            this.getDetail();
        },

        methods: {
            getDetail() {
                this.request({
                    url: '/platform_config/list',
                    data: {
                        config_group: ""
                    },
                    loading: true,
                    success: data => {
                        let json = {};
                        data.forEach(function (item,i){
                          if(item.config_item_code=='STATION_WITHDRAWAL_RATE' || item.config_item_code=='WITHDRAWAL_RATE'){
                            json[item.config_item_code] = parseFloat(item.config_item_value) * 100;
                          }else{
                            json[item.config_item_code] = item.config_item_value;
                          }
                        });
                        this.$nextTick(() => {
                            if(this.$refs.form1)this.$refs.form1.set(json);
                            if(this.$refs.form2)this.$refs.form2.set(json);
                            if(this.$refs.form3)this.$refs.form3.set(json);
                        });
                    }
                });
            },


            save() {
                let data1 = this.$refs.form1?this.$refs.form1.get():{};
                let data2 = this.$refs.form2?this.$refs.form2.get():{};
                let data3 = this.$refs.form3?this.$refs.form3.get():{};
                let submitData = Object.assign({},data1,data2,data3);
                let platform_config_list = [];
                for (let key in submitData) {
                    if(key=='STATION_WITHDRAWAL_RATE' || key=='WITHDRAWAL_RATE'){
                        platform_config_list.push({
                            config_item_code: key,
                            config_item_value: submitData[key] ? parseFloat(submitData[key].toString()) / 100 : 0
                        });
                    }else{
                        platform_config_list.push({
                            config_item_code: key,
                            config_item_value: submitData[key] ? submitData[key].toString() : ''
                        });
                    }
                }
                this.request({
                    url: '/platform_config/edit',
                    data: {
                        platform_config_list: platform_config_list
                    },
                    loading: true,
                    success: data => {
                        this.$store.dispatch('getSystemConfig');
                        this.$message({
                            text: '保存成功',
                            icon: 'success'
                        });
                        //刷新页面
                        this.getDetail();
                    }
                });
            }
        }
    }
</script>

<style lang="stylus" scoped>


</style>